module.exports = __webpack_public_path__ + "img/1e52ac2cc2844dc8e4fa1f84c6b64b7f.svg";